<div checkoutCy="stepper" class="stepper-wrapper">
    @for (step of steps; track step; let index = $index) {
        <div
            checkoutCy="breadcrumb-{{ step.key }}"
            [ngClass]="{
                'is-current': currentStep ? step.key === currentStep.key : index === 0,
                'is-done': currentStep?.order > index
            }"
            class="stepper-item"
            [attr.data-label]="step.shortLabel || step.label"
            step="1"
        >
            <div class="step-label">{{ step.shortLabel || step.label }}</div>
        </div>
        <div checkoutCy="stepper-item" class="step-bars"></div>
    }
    <div class="step-count">{{ currentStep ? currentStep?.order + 1 : 1 }}/{{ steps.length }}</div>
</div>
